import CommonProcess from 'app/components/OrderPayment/Common/CommonProcess';
import React from 'react';

const AlipayPayment = () => {
  return <CommonProcess />;
};

export default AlipayPayment;
